import { render } from "./ExtraOpmerkingenView.vue?vue&type=template&id=6b21c054"
import script from "./ExtraOpmerkingenView.vue?vue&type=script&lang=js"
export * from "./ExtraOpmerkingenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__